import { IModel, IObjectStore, isIdentifiable } from "@/loader";

export abstract class DBEntity<I, T extends IModel<I>> implements IObjectStore<I, T> {
	public list: T[] = [];

	public abstract getter(a: I | T, ...id: number[]): boolean;

	public abstract create(data: I | T): T;

	public abstract match(a: T, b: I | T): boolean;

	public abstract is(item: any): item is T;

	public clear(): this {
		this.list = this.list.filter(i => !isIdentifiable(i) || (i.id && i.id > 0));
		return this;
	}

	public get(...id: number[]): T | null {
		return this.list.find(item => this.getter(item, ...id)) || null;
	}

	public insert(item: I | T): T {
		let result: T | undefined = this.list.find(i => this.match(i, item));
		if (!result) {
			if (this.is(item)) {
				result = item;
			} else {
				result = this.create(item);
			}
			this.list.push(result);
		}
		return result;
	}

	public insertMany(items: (I | T)[]): T[] {
		let result: T[] = [];
		items.forEach(i => result.push(this.insert(i)));
		return result;
	}

	public insertOrUpdate(item: I | T): T {
		let result: T | undefined = this.list.find(i => this.match(i, item));
		if (!result) {
			if (this.is(item)) {
				result = item;
			} else {
				result = this.create(item);
			}
			this.list.push(result);
		} else {
			result.update(<I>item);
		}
		return result;
	}

	public insertOrUpdateMany(items: (I | T)[]): T[] {
		let result: T[] = [];
		items.forEach(i => result.push(this.insertOrUpdate(i)));
		return result;
	}

	public remove(item: T, force?: boolean): this {
		let result: T | undefined = this.list.find(i => this.match(i, item));
		if (result) {
			this.list.remove(result, force);
		}
		return this;
	}

	public removeMany(items: T[], force?: boolean): this {
		this.list.removeMany(items, force);
		return this;
	}
}
